export const searchParamsNames = {
    clientAuthQuery: 'sign-in-redirect',
    managerAuthExtraQuery: 'extra',
    managerAuthExtraTokenQuery: 'token',
    managerAuthQuery: 'return_url',
    redirectTo: 'redirect-to',
    unavailableContentType: 'unavailable-content-type',
    voxAccountId: 'account_id',
    voxApiKey: 'api_key',
};
